export const parseErrors = (response) => {
  if ('undefined' === typeof response.violations) {
    return [response['hydra:description']];
  }

  let messages = [];
  response.violations.map(violation => {
    messages.push(violation.message);
  });

  return messages;
}
